<template>
  <div class="welfare" style="padding-top: 44px;">
    <back-header title="福利中心" />
    <scroll clickable class="wel-scroll">
<!--      <a href="https://www.baidu.com/" class="banner">-->
<!--        <img src="./banner@2x.png" alt="">-->
<!--      </a>-->
<!--      <div class="links">-->
<!--        <a href="https://www.baidu.com/"><img src="./pic1@2x.png" alt=""></a>-->
<!--        <a href="https://www.baidu.com/"><img src="./pic2@2x.png" alt=""></a>-->
<!--        <a href="https://www.baidu.com/"><img src="./pic3@2x.png" alt=""></a>-->
<!--      </div>-->
      <h4 class="sub-title">精品推荐</h4>
      <div v-for="item in list" :key="item.id" class="app">
        <img :src="'https://api.53gogogo.com' + item.icon" alt="">
        <div class="info">
          <h6>{{ item.name }} <span>{{ item.category }}</span></h6>
          <p>{{ item.dl_count }}万次下载 <img v-for="i in 5" :key="i" src="./star@2x.png" alt=""></p>
          <span>{{ item.sub_title }}</span>
        </div>
        <div class="btn" @click="download(item.dl_url)">下载</div>
      </div>
    </scroll>
  </div>
</template>

<script>
import BackHeader from '../../components/back-header/back-header'
import Scroll from '../../components/scroll/scroll'
import { post } from '../../common/js/http'

export default {
  name: 'welfare',
  components: {
    Scroll,
    BackHeader
  },
  data() {
    return {
      list: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList() {
      post('/webapi/apps/getlist')
        .then(({ data: { data } }) => {
          this.list = data
        })
    },
    download(url) {
      this.$jsCallNative('openurl', {
        url
      })
    }
  }
}
</script>

<style scoped lang="stylus">
.welfare
  height 100%
  box-sizing border-box
  .wel-scroll
    padding 0 30px
    .banner
      display block
      margin-top 10px
      margin-bottom 23px
      width 100%
      height 280px
      &>img
        width 100%
    .links
      display flex
      justify-content space-between
      height 137px
      &>a
        width 205px
        height 137px
        &>img
          width 100%
    .sub-title
      margin-top 40px
      margin-bottom 35px
      color #333333
      font-weight bold
      font-size 32px
    .app
      display flex
      margin-bottom 28px
      padding 31px 27px 31px 20px
      box-shadow 0px 1px 18px 0px rgba(172, 116, 255, 0.18)
      &>img
        width 131px
        height 131px
      .info
        margin-left 42px
        flex 1
        &>h6
          margin-bottom 18px
          display flex
          align-items center
          font-size 30px
          color #333333
          &>span
            margin-left 12px
            display inline-block
            padding 0 13px
            height 29px
            line-height 29px
            border-radius 15px
            background #E8D8FF
            font-size 20px
            color #AC74FF
        &>p
          margin-bottom 25px
          display flex
          align-items center
          font-size 24px
          color #919191
          &>img
            width 18px
            margin-left 13px
        &>span
          font-size 24px
          color #919191
      .btn
        width 79px
        height 50px
        line-height 50px
        text-align center
        font-size 24px
        color #FFFFFF
        border-radius 10px
        background #AC74FF
</style>
